import { render, staticRenderFns } from "./history_modal.vue?vue&type=template&id=04f9d858&scoped=true&"
import script from "./history_modal.vue?vue&type=script&lang=js&"
export * from "./history_modal.vue?vue&type=script&lang=js&"
import style0 from "./history_modal.vue?vue&type=style&index=0&id=04f9d858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9d858",
  null
  
)

export default component.exports